export const getArrayGreaterThanOrEqualTo = (array: any[] | readonly any[], value: any) =>
  array.reduce((arr, e, i) => (i >= array.indexOf(value) ? [...arr, e] : arr), []);

export const getArrayLessThanOrEqualTo = (array: any[] | readonly any[], value: any) =>
  array.reduce((arr, e, i) => (i <= array.indexOf(value) ? [...arr, e] : arr), []);
